function normalizeShopifyProduct(product, index) {
  if (!product || !product.handle) return null;

  return {
    name: product.title,
    handle: product.handle,
    key: `band${index + 1}`,
    price: product.price / 100,
    image: product.featured_image
      ? product.featured_image.split('/').pop()
      : "",
    variants: product.variants || [],
  };
}


const shopifyBands = Object.values(window.revaStackBuilderProducts || {})
  .map(normalizeShopifyProduct)
  .filter(Boolean);

const activeBands = shopifyBands;
console.table(
  activeBands.map(b => ({
    name: b.name,
    key: b.key,
    handle: b.handle
  }))
);



const positions = ["Top", "Middle", "Bottom"];

const initialSelections = {
  Top: 0,
  Middle: 1,
  Bottom: 2,
};

const initialSize = "7";

const selections = { ...initialSelections };
let selectedSize = initialSize;

const selectorsElement = document.getElementById("selectors");
const selectedListElement = document.getElementById("selected-list");
const totalPriceElement = document.getElementById("total-price");
const addStackButton = document.getElementById("add-stack");
const resetStackButton = document.getElementById("reset-stack");
const ringSizeSelect = document.getElementById("ring-size");

function formatPrice(price) {
  return `$${price}`;
}

function getImagePath(image) {
  return `/cdn/shop/files/${image}`;
}

function cycleBand(position, direction) {
  const currentIndex = selections[position];
  const nextIndex = (currentIndex + direction + activeBands.length) % activeBands.length;

  selections[position] = nextIndex;
  render();
}

function createPositionControl(position) {
  const article = document.createElement("article");
  article.className = "position-control";

  article.innerHTML = `
    <p class="position-label">${position}</p>
    <div class="selector-row">
      <button type="button" class="arrow-button" data-direction="-1" aria-label="Previous ${position} band">&lsaquo;</button>
      <div class="band-image-wrap">
        <img data-role="selector-image" alt="">
      </div>
      <button type="button" class="arrow-button" data-direction="1" aria-label="Next ${position} band">&rsaquo;</button>
    </div>
    <div class="band-details">
      <p class="band-name" data-role="selector-name"></p>
      <p class="band-price" data-role="selector-price"></p>
    </div>
  `;

  article.querySelectorAll(".arrow-button").forEach((button) => {
    button.addEventListener("click", () => {
      console.log("Arrow clicked:", position, button.dataset.direction);
cycleBand(position, Number(button.dataset.direction));
    });
  });

  return article;
}

function renderSelectors() {
  positions.forEach((position) => {
    const control = document.querySelector(`[data-position="${position}"]`);
    const band = activeBands[selections[position]];
    const image = control.querySelector('[data-role="selector-image"]');

    image.src = getImagePath(band.image);
    image.alt = `${position} selected band: ${band.name}`;
    control.querySelector('[data-role="selector-name"]').textContent = band.name;
    control.querySelector('[data-role="selector-price"]').textContent =
      formatPrice(band.price);
  });
}

function renderPreview() {
  positions.forEach((position) => {
    const band = activeBands[selections[position]];
    const image = document.getElementById(`preview-${position.toLowerCase()}`);

    image.src = getImagePath(band.image);
    image.alt = `${position} preview: ${band.name}`;
  });
}

function renderSummary() {
  selectedListElement.innerHTML = "";

  const sizeItem = document.createElement("li");
  sizeItem.dataset.summaryLabel = "Ring Size";
  sizeItem.innerHTML = `
    <span>Size</span>
    <strong>${selectedSize}</strong>
  `;
  selectedListElement.appendChild(sizeItem);

  const total = positions.reduce((sum, position) => {
    const band = activeBands[selections[position]];
    const item = document.createElement("li");
    item.dataset.summaryLabel = `${position} Ring`;

    item.innerHTML = `
      <span>${band.name}</span>
      <strong>${formatPrice(band.price)}</strong>
    `;

    selectedListElement.appendChild(item);
    return sum + band.price;
  }, 0);

  totalPriceElement.textContent = formatPrice(total);
}

function render() {
  ringSizeSelect.value = selectedSize;
  renderSelectors();
  renderPreview();
  renderSummary();
}

function resetStack() {
  positions.forEach((position) => {
    selections[position] = initialSelections[position];
  });

  selectedSize = initialSize;
  render();
}

function getSelectedStack() {
  const selectedBands = positions.map((position) => {
    const band = activeBands[selections[position]];

    return {
  position,
  key: band.key,
  name: band.name,
  price: band.price,
  image: band.image,
};
  });

  const totalPrice = selectedBands.reduce((sum, band) => sum + band.price, 0);

  return {
    size: selectedSize,
    bands: selectedBands,
    totalPrice,
  };
}

positions.forEach((position) => {
  const control = createPositionControl(position);
  control.dataset.position = position;
  selectorsElement.appendChild(control);
});

addStackButton.addEventListener("click", async () => {
addStackButton.disabled = true;
addStackButton.textContent = "Adding...";
  
  const stack = getSelectedStack();

for (const band of [...stack.bands].reverse()) {
  const product = activeBands.find((p) => p.key === band.key);
  if (!product) continue;

  const variant = product.variants.find(
    (v) => v.option1 === stack.size
  );

console.log("Adding:", product.name, "size:", stack.size, "variant:", variant?.id);

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id: variant.id,
      quantity: 1
    })
  });
}

const stackSuccess = document.getElementById("stack-success");
if (stackSuccess) {
  stackSuccess.hidden = false;
} else {
  alert("Stack added to cart. Please check your cart.");
}
resetStack();
addStackButton.disabled = false;
addStackButton.textContent = "Add Stack";

console.log("Selected Reva stack:", stack);
});
ringSizeSelect.addEventListener("change", () => {
  selectedSize = ringSizeSelect.value;
  render();
});

resetStackButton.addEventListener("click", resetStack);

render();